import {createContext,useCallback,useContext,useEffect,useRef,useState} from 'react';
import {traderAPI,useTraderAuth} from '../context/TraderAuthContext';
import {watchLiveRefresh} from '../../hooks/liveRefresh';

const Context=createContext(null);
export const TraderNotificationProvider=({children})=>{
  const {user}=useTraderAuth(),owner=user?.id;
  const [count,setCount]=useState(null),[error,setError]=useState(false),[version,setVersion]=useState(0);
  const current=useRef(owner);current.current=owner;
  const changed=useCallback(()=>{setVersion(v=>v+1);window.dispatchEvent(new Event('trader-notifications-changed'));},[]);
  useEffect(()=>{
    setCount(null);setError(false);if(!owner)return;
    let active=true,busy=false;const controller=new AbortController();
    const refresh=async()=>{if(busy||!active)return;busy=true;try{const {data}=await traderAPI.get('/api/trader/notification-inbox',{signal:controller.signal,timeout:20000});if(active&&current.current===owner){setCount(data.unread_count);setError(false);}}catch(e){if(active&&current.current===owner)setError(true);}finally{busy=false;}};
    refresh();const stop=watchLiveRefresh(refresh);window.addEventListener('trader-notifications-changed',refresh);
    return()=>{active=false;controller.abort();stop();window.removeEventListener('trader-notifications-changed',refresh);};
  },[owner]);
  return <Context.Provider value={{count,error,version,changed}}>{children}</Context.Provider>;
};
export const useTraderNotifications=()=>useContext(Context);

export const NotificationBadge=({id})=>{
  const {count,error}=useTraderNotifications();
  return count>0||error?<span data-testid={id} title={error?'Notification sync unavailable':String(count)} className={`trader-notification-badge ${error?'notification-sync-error':''}`}>{error?'!':count>99?'99+':count}</span>:null;
};